<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<h2 class="h2c"><a id="page_5"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="para"> </p>
<p class="toc"><a href="#/xhtml/chapter01#ch01">Getting started</a></p>
<p class="toc"><span href="#/xhtml/chapter02#ch02" title="Link target outside of Sample">The basics</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch03" title="Link target outside of Sample">Pests and diseases</span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch04" title="Link target outside of Sample">Growing vegetables</span></p>
<p class="toc"><span href="#/xhtml/chapter05#ch05" title="Link target outside of Sample">Growing fruit</span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample">Greenhouses and polythene tunnels</span></p>
<p class="para"> </p>
<p class="toca"><span href="#/xhtml/bm01" title="Link target outside of Sample">Suppliers</span></p>
<figure class="imagey"><img alt="Illustration" src="images/f0005-01.jpg"/></figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6f66bcf4